// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Scrollable from "../../../../../../../library/components/Scrollable.bs.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as WorkSpaceContext from "../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ViewUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as DriverIncentiveListTable from "./DriverIncentiveListTable.bs.js";
import * as IncentiveDashboardRepoManager from "../../../../app/incentive/repo/IncentiveDashboardRepoManager.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as DriverIncentiveListStateMachine from "./DriverIncentiveListStateMachine.bs.js";

function loadData(off_set, msisdn, dispatch, loadedData, country) {
  var offset = String(off_set);
  var RepoInstance = IncentiveDashboardRepoManager.getIncentivesRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchIncentives, msisdn, offset, country);
              }), (function (res) {
                return Curry._1(dispatch, /* UpdateDriverIncentiveList */{
                            driver_incentive_list: {
                              TAG: /* Live */1,
                              _0: Pervasives.$at(Belt_Option.getWithDefault(loadedData, /* [] */0), res)
                            },
                            offset: off_set + List.length(res) | 0,
                            end_of_list: List.length(res) === 0
                          });
              }), (function (error) {
                return Curry._1(dispatch, /* UpdateDriverIncentiveList */{
                            driver_incentive_list: {
                              TAG: /* Error */2,
                              _0: error
                            },
                            offset: off_set,
                            end_of_list: false
                          });
              }));
}

var IncentiveListLoader = {
  loadData: loadData
};

function DriverIncentiveListCmp(Props) {
  var msisdn = Props.msisdn;
  var initialState_driver_incentive_list = {
    TAG: /* Loading */0,
    _0: undefined
  };
  var initialState = {
    driver_incentive_list: initialState_driver_incentive_list,
    msisdn: msisdn,
    offset: 0,
    end_of_list: false
  };
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(DriverIncentiveListStateMachine.reducer, initialState);
  var dispatch = match$1[1];
  var state = match$1[0];
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  React.useEffect((function () {
          loadData(state.offset, msisdn, dispatch, ViewUtils$Catalyst.extractLiveData(state.driver_incentive_list), country);
          
        }), []);
  var onScrollEndCallback = function (param) {
    if (state.end_of_list) {
      return ;
    } else {
      return loadData(state.offset, msisdn, dispatch, ViewUtils$Catalyst.extractLiveData(state.driver_incentive_list), country);
    }
  };
  var data = state.driver_incentive_list;
  switch (data.TAG | 0) {
    case /* Loading */0 :
        var data$1 = data._0;
        if (data$1 !== undefined) {
          return React.createElement(Scrollable.make, {
                      height: "100%",
                      onScrollEndCallback: (function (param) {
                          
                        }),
                      children: React.createElement(DriverIncentiveListTable.make, {
                            tableData: data$1,
                            workspace_dispatch: workspaceDispatch,
                            msisdn: msisdn
                          })
                    });
        } else {
          return React.createElement(CircularLoader$Catalyst.make, {});
        }
    case /* Live */1 :
        return React.createElement(Scrollable.make, {
                    height: "100%",
                    onScrollEndCallback: onScrollEndCallback,
                    children: React.createElement(DriverIncentiveListTable.make, {
                          tableData: data._0,
                          workspace_dispatch: workspaceDispatch,
                          msisdn: msisdn
                        })
                  });
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: data._0
                  });
    
  }
}

var make = DriverIncentiveListCmp;

export {
  IncentiveListLoader ,
  make ,
  
}
/* react Not a pure module */
